import {createAction} from "redux-actions";
import {apiGet, apiPost} from "./api";

const actions = {
    //get data
    full_public_send_data: createAction("FULL_PUBLIC_SEND_DATA"),
    full_public_initial_data_succeeded: createAction(
        "FULL_PUBLIC_INITIAL_DATA_SUCCEEDED"
    ),
    full_public_failed: createAction("FULL_PUBLIC_FAILED"),

    //step postcode
    postcode_search: createAction("POSTCODE_SEARCH"),
    postcode_succeeded: createAction("POSTCODE_SUCCEEDED"),
    postcode_failed: createAction("POSTCODE_FAILED"),

    add: createAction("FROM_ADD_ITEM"),
    remove: createAction("FROM_REMOVE_ITEM"),

    submit: createAction("SUBMIT"),

    reset: createAction('FULL_PUBLIC_RESET'),
};

export default actions;

//sendData
const formSendData = (response, name) => {
    return {
        type: actions.full_public_send_data.toString(),
        name,
        payload: response,
    };
};
const formInitialDataSucceeded = (response, name) => {
    return {
        type: actions.full_public_initial_data_succeeded.toString(),
        name,
        payload: response,
    };
};

const formFailed = (response, name) => {
    return {
        type: actions.full_public_failed.toString(),
        name,
        payload: response,
    };
};

/********** POSTCODE ************/
const postcodeSearch = (response, name) => {
    return {
        type: actions.postcode_search.toString(),
        name,
        payload: response,
    };
};
const postcodeSucceeded = (response, name) => {
    return {
        type: actions.postcode_succeeded.toString(),
        name,
        payload: response,
    };
};
const postcodeFailed = (response, name) => {
    return {
        type: actions.postcode_failed.toString(),
        name,
        payload: response,
    };
};

export const searchPostcode = (name, postcode) => {
    return apiGet(
        "api/lookup/postcode",
        postcode,
        (res) => postcodeSearch(res, name),
        (res) => postcodeSucceeded(res, name),
        (res) => postcodeFailed(res, name)
    );
};

export const getFormData = (name, uuid) => {
    const path = name.replace("full_public_", "");

    return apiGet(
        `api/lead/${path.replace(/_/g, "-")}`,
        {uuid},
        (res) => formSendData(res, name),
        (res) => formInitialDataSucceeded(res, name),
        (res) => formFailed(res, name)
    );
};

export const submit = (name, data) => {
    const path = name.replace("full_public_", "");

    return apiPost(
        `api/lead/${path.replace(/_/g, "-")}`,
        data,
        (res) => formSendData(res, name),
        (res) => formInitialDataSucceeded(res, name),
        (res) => formFailed(res, name)
    );
};

export const submitUnsubscribe = (name, data) => {
    return apiPost(
        'api/unsubscribe',
        data,
        (res) => formSendData(res, name),
        (res) => formInitialDataSucceeded(res, name),
        (res) => formFailed(res, name)
    );
};

export const submitResubmit = (name, data) => {
    return apiPost(
        'api/resubmit',
        data,
        (res) => formSendData(res, name),
        (res) => formInitialDataSucceeded(res, name),
        (res) => formFailed(res, name)
    );
};

export const submitSchedule = (name, data) => {
    return apiPost(
        'api/schedule-lead-conversion',
        data,
        (res) => formSendData(res, name),
        (res) => formInitialDataSucceeded(res, name),
        (res) => formFailed(res, name)
    );
};

export const addField = (name, field) => {
    return {
        type: actions.add.toString(),
        name,
        payload: field,
    };
};
export const removeField = (name, field) => {
    return {
        type: actions.remove.toString(),
        name,
        payload: field,
    };
};


export const reset = (name) => {
    return {
        type: actions.reset.toString(),
        name,
    };
};
